import i18next from 'i18next';

i18next.addResources('es_CL', 'EmptyCart', {
  noItemsTitle: 'Aún no tienes nada en tu orden',
  noItemsSubtitle: 'Agrega productos para comenzar'
});
